
        export default {"base":"themes/base.js"};
    